import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import './InnerQuoteCarouselAlt.scss';

class InnerQuoteCarouselAltQuery extends Query<{id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphInnerQuoteCarousel {
          fieldNameAndTitle
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
          }
        }
      }
    }
  }
}
`;

// eslint-disable-next-line no-unused-vars
const InnerQuoteCarouselAlt = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <InnerQuoteCarouselAltQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            // Ensure Image Exists
            if (!(field && field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url)) return null;

            markComponentLoadedAs(id, true);

            return (
                <div className="testimonialsCarousel__card swiper-slide">
                    <div className="testimonialsCarousel__cardInner">
                        <img src={field.fieldObjectImgMedia.entity.fieldMediaImage.url} alt={field.fieldObjectImgMedia.entity.fieldMediaImage.title || field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                        <div className="testimonialsCarousel__cardText">
                            <p>“Wse are at the forefront of blending technology and finance, but we don’t expect new
                                hires to have a deep knowledge of finance. We are looking for people who can get to
                                the root of the problem and think outside the box. That’s what allows us to make
                                trading more efficient.”</p>
                            <span>Christine, Head of Trading Technology, New York</span>
                        </div>
                    </div>
                </div>
            );
        }}
    </InnerQuoteCarouselAltQuery>
);

InnerQuoteCarouselAlt.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default InnerQuoteCarouselAlt;



// WEBPACK FOOTER //
// ./frontend/components/QuoteCarouselAlt/InnerQuoteCarouselAlt.jsx